import GeolocateControl from './GeolocateControl';

export default GeolocateControl;
